<template>
    <v-hover v-slot="{ hover }">
        <v-card :elevation="hover ? 6 : 2">
            <v-card-text>
                <div ref="chart" style="width: 100%;height:350px;"></div>
            </v-card-text>
        </v-card>
    </v-hover>

</template>
<script>
import * as echarts from 'echarts';

export default {
    props: {
        update: {
            type: Boolean
        },
        axis: {
            type: Array
        },
        peak: {
            type: Array
        },
        offPeak: {
            type: Array
        },
        demand: {
            type: Array
        }
    },
    watch: {
        update() {
            setTimeout(() => {
            this.myChart.resize()
            }, 80);
        },
        axis(value) {
            this.myChart.setOption({
                xAxis: {
                    data: value
                },
                series: [
                    {
                        name: 'Peak',
                        type: 'bar',
                        stack: 'energy',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.peak
                    },
                    {
                        name: 'Off Peak',
                        type: 'bar',
                        stack: 'energy',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.offPeak
                    },
                    {
                        name: 'Demand',
                        type: 'line',
                        yAxisIndex: 1,
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                        data: this.demand
                    }

                ]
            });
            this.myChart.resize()
        }
    },
    data() {
        return {
            option: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    },
                    formatter: (params) => {
                        let peak = 0
                        let offPeak = 0
                        let demand = 0
                        let peakMarker = ''
                        let offPeakMarker = ''
                        let demandMarker = ''
                        params.forEach((p) => {
                            if (p.seriesName === 'Peak') {
                                peak = Number(p.value) || 0
                                peakMarker = p.marker
                            } else if (p.seriesName === 'Off Peak') {
                                offPeak = Number(p.value) || 0
                                offPeakMarker = p.marker
                            } else if (p.seriesName === 'Demand') {
                                demand = Number(p.value) || 0
                                demandMarker = p.marker
                            }
                        })
                        const total = peak + offPeak
                        return [
                            params[0].axisValue,
                            `${peakMarker}Peak: ${peak} kWh`,
                            `${offPeakMarker}Off Peak: ${offPeak} kWh`,
                            '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#5470c6;"></span>Total: ' + total + ' kWh',
                            `${demandMarker}Demand: ${demand} kW`,
                        ].join('<br/>')
                    },
                },
                toolbox: {
                    itemGap: 20,
                    show: true,
                    showTitle: false, // hide the default text so they don't overlap each other
                    feature: {
                        restore: { show: true },
                        magicType: {
                             type: ['line', 'bar']
                         },
                        saveAsImage: {
                            show: true,
                            title: 'Save As Image'
                        },
                        dataView: {
                            show: true,
                            title: 'Data View'
                        },
                    }
                },
                legend: {},
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: [
                    {
                        type: 'value',
                        name: 'Usage (kWh)',
                        axisLabel: {
                            formatter: '{value} kWh'
                        }
                    },
                    {
                        type: 'value',
                        name: 'Demand (kW)',
                        axisLabel: {
                            formatter: '{value} kW'
                        }
                    }
                ],
                series: []
            }
        }
    },
    mounted() {
        this.myChart = echarts.init(this.$refs.chart);
        this.myChart.setOption(this.option);
    },
}

</script>